export { ProductDescriptionAccordionRenderer } from './ProductDescriptionAccordionRenderer'
